// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.login-page {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, var(--primary-color) 0%, #1e293b 100%);
  padding: 2rem;
}

.login-container {
  display: flex;
  max-width: 900px;
  width: 100%;
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  border-radius: var(--radius-xl);
  overflow: hidden;
  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.5);
  border: 1px solid rgba(255, 255, 255, 0.1);
  animation: fadeIn 0.8s ease forwards;
}

.login-card {
  flex: 1 1;
  padding: 4rem;
  background: var(--white);
}

.login-header {
  text-align: center;
  margin-bottom: 3rem;
}

.login-logo {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
  margin-bottom: 1rem;
}

.logo-img-login {
  height: 80px;
  border-radius: var(--radius-md);
  box-shadow: var(--shadow-md);
}

.login-logo h2 {
  font-size: 2rem;
  color: var(--primary-color);
  font-weight: 700;
}

.login-header p {
  color: var(--text-light);
}

.login-form {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

.form-group {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.form-group label {
  font-size: 0.875rem;
  font-weight: 600;
  color: var(--text-dark);
}

.form-group input {
  padding: 1rem;
  border: 2px solid #e2e8f0;
  border-radius: var(--radius-md);
  font-size: 1rem;
  transition: all 0.3s ease;
  background: #f8fafc;
}

.form-group input:focus {
  outline: none;
  border-color: var(--secondary-color);
  background: var(--white);
  box-shadow: 0 0 0 4px rgba(245, 158, 11, 0.1);
}

.login-button {
  background: var(--primary-color);
  color: var(--white);
  padding: 1rem;
  border: none;
  border-radius: var(--radius-md);
  font-size: 1rem;
  font-weight: 600;
  margin-top: 1rem;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 0.5rem;
}

.login-button:hover {
  background: var(--secondary-color);
  transform: translateY(-2px);
  box-shadow: var(--shadow-md);
}

.login-error {
  background: #fef2f2;
  color: #ef4444;
  padding: 1rem;
  border-radius: var(--radius-md);
  font-size: 0.875rem;
  text-align: center;
  border: 1px solid #fecaca;
}

.login-sidebar {
  flex: 1 1;
  padding: 4rem;
  color: var(--white);
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.sidebar-content h3 {
  font-size: 1.5rem;
  margin-bottom: 2rem;
  color: var(--secondary-color);
}

.features-list {
  list-style: none;
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

.features-list li {
  display: flex;
  align-items: center;
  gap: 1rem;
  font-size: 1.1rem;
}

.security-note {
  margin-top: 4rem;
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 1.5rem;
  background: rgba(0, 0, 0, 0.2);
  border-radius: var(--radius-md);
}

.login-footer {
  margin-top: 3rem;
  text-align: center;
  font-size: 0.875rem;
}

.back-link {
  color: var(--primary-color);
  font-weight: 600;
}

.back-link:hover {
  color: var(--secondary-hover);
  text-decoration: underline;
}

@media (max-width: 768px) {
  .login-container {
    flex-direction: column;
  }
  .login-sidebar {
    display: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/AdminLogin.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,0EAA0E;EAC1E,aAAa;AACf;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,WAAW;EACX,oCAAoC;EACpC,2BAA2B;EAC3B,mCAAmC;EACnC,+BAA+B;EAC/B,gBAAgB;EAChB,gDAAgD;EAChD,0CAA0C;EAC1C,oCAAoC;AACtC;;AAEA;EACE,SAAO;EACP,aAAa;EACb,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,+BAA+B;EAC/B,4BAA4B;AAC9B;;AAEA;EACE,eAAe;EACf,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,+BAA+B;EAC/B,eAAe;EACf,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,oCAAoC;EACpC,wBAAwB;EACxB,6CAA6C;AAC/C;;AAEA;EACE,gCAAgC;EAChC,mBAAmB;EACnB,aAAa;EACb,YAAY;EACZ,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,kCAAkC;EAClC,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,+BAA+B;EAC/B,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,SAAO;EACP,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,8BAA8B;EAC9B,+BAA+B;AACjC;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;EAC7B,0BAA0B;AAC5B;;AAEA;EACE;IACE,sBAAsB;EACxB;EACA;IACE,aAAa;EACf;AACF","sourcesContent":[".login-page {\n  min-height: 100vh;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: linear-gradient(135deg, var(--primary-color) 0%, #1e293b 100%);\n  padding: 2rem;\n}\n\n.login-container {\n  display: flex;\n  max-width: 900px;\n  width: 100%;\n  background: rgba(255, 255, 255, 0.1);\n  backdrop-filter: blur(20px);\n  -webkit-backdrop-filter: blur(20px);\n  border-radius: var(--radius-xl);\n  overflow: hidden;\n  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.5);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  animation: fadeIn 0.8s ease forwards;\n}\n\n.login-card {\n  flex: 1;\n  padding: 4rem;\n  background: var(--white);\n}\n\n.login-header {\n  text-align: center;\n  margin-bottom: 3rem;\n}\n\n.login-logo {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 1rem;\n  margin-bottom: 1rem;\n}\n\n.logo-img-login {\n  height: 80px;\n  border-radius: var(--radius-md);\n  box-shadow: var(--shadow-md);\n}\n\n.login-logo h2 {\n  font-size: 2rem;\n  color: var(--primary-color);\n  font-weight: 700;\n}\n\n.login-header p {\n  color: var(--text-light);\n}\n\n.login-form {\n  display: flex;\n  flex-direction: column;\n  gap: 1.5rem;\n}\n\n.form-group {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n\n.form-group label {\n  font-size: 0.875rem;\n  font-weight: 600;\n  color: var(--text-dark);\n}\n\n.form-group input {\n  padding: 1rem;\n  border: 2px solid #e2e8f0;\n  border-radius: var(--radius-md);\n  font-size: 1rem;\n  transition: all 0.3s ease;\n  background: #f8fafc;\n}\n\n.form-group input:focus {\n  outline: none;\n  border-color: var(--secondary-color);\n  background: var(--white);\n  box-shadow: 0 0 0 4px rgba(245, 158, 11, 0.1);\n}\n\n.login-button {\n  background: var(--primary-color);\n  color: var(--white);\n  padding: 1rem;\n  border: none;\n  border-radius: var(--radius-md);\n  font-size: 1rem;\n  font-weight: 600;\n  margin-top: 1rem;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.login-button:hover {\n  background: var(--secondary-color);\n  transform: translateY(-2px);\n  box-shadow: var(--shadow-md);\n}\n\n.login-error {\n  background: #fef2f2;\n  color: #ef4444;\n  padding: 1rem;\n  border-radius: var(--radius-md);\n  font-size: 0.875rem;\n  text-align: center;\n  border: 1px solid #fecaca;\n}\n\n.login-sidebar {\n  flex: 1;\n  padding: 4rem;\n  color: var(--white);\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n}\n\n.sidebar-content h3 {\n  font-size: 1.5rem;\n  margin-bottom: 2rem;\n  color: var(--secondary-color);\n}\n\n.features-list {\n  list-style: none;\n  display: flex;\n  flex-direction: column;\n  gap: 1.5rem;\n}\n\n.features-list li {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n  font-size: 1.1rem;\n}\n\n.security-note {\n  margin-top: 4rem;\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n  padding: 1.5rem;\n  background: rgba(0, 0, 0, 0.2);\n  border-radius: var(--radius-md);\n}\n\n.login-footer {\n  margin-top: 3rem;\n  text-align: center;\n  font-size: 0.875rem;\n}\n\n.back-link {\n  color: var(--primary-color);\n  font-weight: 600;\n}\n\n.back-link:hover {\n  color: var(--secondary-hover);\n  text-decoration: underline;\n}\n\n@media (max-width: 768px) {\n  .login-container {\n    flex-direction: column;\n  }\n  .login-sidebar {\n    display: none;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
